import type { ImplantsViewDataRxApi } from '@modules/teeth-diagram/models/implants-view-data';

const trimOrNull = (value?: string | null): string | null => {
	if (value == null) {
		return null;
	}

	const t = value.trim();

	return t.length > 0 ? t : null;
};

const MAIN_SEP = ' \u00B7 ';
const PART_INNER_SEP = ' + ';

/**
 * One-line implants summary for intuitive treatment list (Implant Based / bridge implant based).
 * **Manufacturer** · **Diameter/Platform** · then either **(Part number + Part supplier)** or **Library supplier(s)**.
 * Connection is omitted. Part + supplier uses a literal ` + ` between the two; library entries use `, `.
 */
export const buildImplantBasedTreatmentPreviewLine = (data: ImplantsViewDataRxApi | null | undefined): string | null => {
	if (data == null) {
		return null;
	}

	const manufacturer = trimOrNull(data.ImplantManufacturerName) ?? trimOrNull(data.ImplantManufacturerId);

	const platform = trimOrNull(data.ImplantPlatformName) ?? trimOrNull(data.ImplantPlatformId);

	const libraryRaw = data.LibrarySuppliers;
	const libraryList = Array.isArray(libraryRaw) ? libraryRaw : [];
	const library = libraryList
		.map(entry => (typeof entry === 'string' ? entry.trim() : String(entry).trim()))
		.filter(entry => entry.length > 0);
	const libraryLine = library.length > 0 ? library.join(', ') : null;

	const partNumber = trimOrNull(data.PartNumber);
	const partSupplier = trimOrNull(data.PartManufacturerName);
	let partLine: string | null = null;

	if (partNumber != null && partSupplier != null) {
		partLine = `${partNumber}${PART_INNER_SEP}${partSupplier}`;
	} else if (partNumber != null) {
		partLine = partNumber;
	} else if (partSupplier != null) {
		partLine = partSupplier;
	}

	const third = partLine ?? libraryLine;

	const segments = [manufacturer, platform, third].filter((p): p is string => p != null && p.length > 0);

	return segments.length > 0 ? segments.join(MAIN_SEP) : null;
};
